module.exports = __webpack_public_path__ + "img/30.c668f8ef.jpg";